import styled, {css} from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";

const CardSkeleton = css`
        position: relative;

        &::before {
                background-color: white;
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                animation: pulse 1.5s infinite ease-in-out;
        }

        .${GLOBAL_STYLE_CONFIG.splitByPrefix('card-top-actions')} {
                opacity: 0;

        }

        .${GLOBAL_STYLE_CONFIG.splitByPrefix('card-media')} {
                flex: 3 0 auto;
        }

        .${GLOBAL_STYLE_CONFIG.splitByPrefix('card-content')} {
                flex: 1 0 auto;
        }

        .${GLOBAL_STYLE_CONFIG.splitByPrefix('card-bottom')} {
                flex: 1 0 auto;
        }

        .${GLOBAL_STYLE_CONFIG.splitByPrefix('card-bottom')},
        .${GLOBAL_STYLE_CONFIG.splitByPrefix('card-media')},
        .${GLOBAL_STYLE_CONFIG.splitByPrefix('card-content')} {
                * {
                        opacity: 0;
                }

                background-color: #e0e0e0;
                position: relative;
                border-radius: var(${GLOBAL_STYLE_CONFIG.variable('card', 'border-radius')}, ${({theme}) => theme.card.borderRadius});
                //min-height: 80px;

                &::before {
                        content: '';
                        display: block;
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;


                        z-index: 3;
                        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
                        animation: shimmer 1.5s infinite;

                }
        }
`


const Card = styled.div`
    border: 1px solid var(${GLOBAL_STYLE_CONFIG.variable('card', 'border-color')}, ${({theme}) => theme.card.borderColor});
    background-color: var(${GLOBAL_STYLE_CONFIG.variable('card', 'bg-color')}, ${(props) => props.theme.card.bgColor});
    border-radius: var(${GLOBAL_STYLE_CONFIG.variable('card', 'border-radius')}, ${({theme}) => theme.card.borderRadius});
    box-shadow: var(${GLOBAL_STYLE_CONFIG.variable('card', 'shadow')}, ${({theme}) => theme.card.shadowPrimary});
    font-size: var(${GLOBAL_STYLE_CONFIG.variable('card', 'font-size')}, clamp(12px, 1vw, 14px));
    font-weight: var(${GLOBAL_STYLE_CONFIG.variable('card', 'font-weight')}, 500);
    font-family: var(${GLOBAL_STYLE_CONFIG.variable('card', 'font-family')}, inherit);
    color: var(${GLOBAL_STYLE_CONFIG.variable('card', 'text-color')}, ${({theme}) => theme.card.textColor});
    padding: var(${GLOBAL_STYLE_CONFIG.variable('card', 'padding')}, 8px 10px);

    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: hidden;
    position: relative;
    height: 100%;

    transition: border-color 0.250ms, box-shadow 0.250ms;

    img {
        max-width: 100%;
        border-radius: 16px;
        overflow: hidden;
    }

    &:hover {
        box-shadow: var(${GLOBAL_STYLE_CONFIG.variable('card', 'hover-shadow')}, ${({theme}) => theme.card.shadowHover});
        border-color: var(${GLOBAL_STYLE_CONFIG.variable('card', 'hover-border-color')}, ${({theme}) => theme.card.hoverBorderColor});;
    }

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('card-title')} {
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 120%; /* 16.8px */
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-align: left;
    }

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('card-bottom')} {
        display: flex;
        flex-direction: row;
        gap: 15px;
        justify-content: space-between;
        margin-top: auto;
        align-items: center;
    }

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('card-top-actions')} {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        top: 10px;
        left: 0;
        right: -2px;
        z-index: 2;

        .${GLOBAL_STYLE_CONFIG.splitByPrefix('badge')} {
            margin-left: auto;
        }
    }

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('card-media')} {
        width: 100%; // или фиксированное значение
        max-height: var(${GLOBAL_STYLE_CONFIG.variable('card', 'media-max-height')}, 178px);
        user-select: none;

        img {
                max-height: 100%;
                max-width: 100%;
                object-fit: contain;
                display: block;
                margin: auto auto;
        }
    }

    /* Анимация */
    @keyframes pulse {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0.4;
        }
        100% {
            opacity: 1;
        }
    }

    @keyframes shimmer {
        0% {
            left: -150px;
        }
        100% {
            left: 100%;
        }
    }

    &.${GLOBAL_STYLE_CONFIG.splitByPrefix('card-skeleton')} {
        ${CardSkeleton}
    }

`


export const StyledCard = styled(Card)`

`

